import React, { useEffect, useState } from "react";
import { Breadcrumb, Button, Col, Row, Card, Table } from "react-bootstrap";
import {
  examtitlelist,
  stuacademicyearlist,
  stuclasslist,
  studivisionlist,
} from "../../../services/master";
import { studentfilter, studentreportcard } from "../../../services/student";
import Select from "react-select";
import { academylist } from "../../../services/admin";
import { toast } from "react-toastify";
import moment from "moment/moment";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

// CHART.JS IMPORTS: Using Bar Chart
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

// CHART.JS COMPONENT REGISTRATION
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export default function Reportcarddetail() {
  const [aclist, setAcList] = useState([]);
  const [acaid, setAcaID] = useState("");

  const [ayear, setAYear] = useState("");
  const [alist, setAList] = useState([]);
  const [stucls, setStuCls] = useState("");
  const [clist, setCList] = useState([]);
  const [stusec, setStuSec] = useState("");
  const [seclist, setSecList] = useState([]);

  const [stuname, setStuName] = useState([]);
  const [stulist, setStuList] = useState([]);

  const [etitle, setETitle] = useState("");
  const [tlist, setTList] = useState([]);

  const [rcard, setRCard] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);
  const [progress, setProgress] = useState({ current: 0, total: 0 });
const [isPdfMode, setIsPdfMode] = useState(false);

  // --- Master Data Fetching and Initialization ---
  useEffect(() => {
    stuclasslist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].class_name,
            });
          }
          setCList(arr);
        }
      }
    });

    studivisionlist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].name,
            });
          }
          setSecList(arr);
        }
      }
    });

    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setAcList(arr);
        }
      }
    });

    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setAcaID(arr[0]);
                listyear(arr[0]);
                setAYear(localStorage.getItem("AYear"));
              }
            }

          }
        }
      });
    } else {
      listyear("");
    }
  }, []);

  function listyear(aid) {
    setAList([]);
    setAYear("");
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    stuacademicyearlist(temp).then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].aca_year,
            });
          }
          setAList(arr);
        }
      }
    });
    examtitlelist(temp).then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].exam_title,
            });
          }
          setTList(arr);
        }
      }
    });
  }

  // --- Filtering and Data Retrieval ---
  function filterstu(faid, fyear, fcls, fsec) {
    setAYear(fyear);
    setStuCls(fcls);
    setStuSec(fsec);
    setStuList([]);
    setStuName([]);
    listcard("", etitle, fyear, fcls, fsec);

    let valid = "";
    if (localStorage.getItem("Role") === "1") {
      if (faid === "") {
        toast.error("Please Select Academy");
        valid = "Please Select Academy";
      }
    } else {
      valid = "";
    }
    if (valid === "") {
      if (fyear !== "" && fcls !== "" && fsec !== "") {
        const temp = new FormData();
        temp.append("year", fyear);
        temp.append("class", fcls);
        temp.append("section", fsec);
        if (localStorage.getItem("Role") === "1" && faid !== "") {
          temp.append("academy", faid.value);
        }
        studentfilter(temp).then((res) => {
          if (res.status === true) {
            let arr = [];
            if (res.data.details.length > 0) {
              for (let i = 0; i < res.data.details.length; i++) {
                arr.push({
                  value: res.data.details[i].user_id,
                  label:
                    res.data.details[i].username +
                    " - " +
                    res.data.details[i].student_name,
                });
              }
            }
            setStuList(arr);
          }
        });
      }
    }
  }

  function listcard(stuid, etit, ayr, scls, ssec) {

    setETitle(etit);
    setRCard([]);
    let valid = "";
    if (ayear !== "" && stucls !== "" && stusec !== "") {
      if (localStorage.getItem("Role") === "1") {
        if (acaid === "") {
          toast.error("Please Select Academy");
          valid = "Please Select Academy";
        }
      } else {
        valid = "";
      }

      let sid = ""
      if (stuid.length > 0) {
        sid = stuid.map(s => s.value).join(",");
      }
      if (valid === "") {
        const temp = new FormData();
        if (localStorage.getItem("Role") === "1" && acaid !== "") {
          temp.append("academy_id", acaid.value);
        }
        temp.append("year_id", ayr);
        temp.append("class_id", scls);
        temp.append("section_id", ssec);
        temp.append("student_id", sid);
        temp.append("exam_title", etit);
        studentreportcard(temp).then((res) => {
          if (res.status === true) {
            setRCard(res.data.details);

          }
        });
      }
    }
  }

  // --- Handlers ---
  function handleStu(e) {
    if (e !== null) {
      setStuName(e);
      listcard(e, etitle, ayear, stucls, stusec);
    } else {
      setStuName([]);
      listcard("", etitle, ayear, stucls, stusec);
    }
  }

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      filterstu(e, ayear, stucls, stusec);
      listyear(e);
    } else {
      setAcaID("");
      filterstu("", ayear, stucls, stusec);
      listyear("");
    }
  }


  // --- Utility Functions ---
  function errorhandle(ev) {
    ev.target.src = require("../../../assets/images/logo/logo.png");
    ev.target.onerror = null;
  }

  const getGrade = (mark, maxMark) => {
    if (!mark || !maxMark) return '-';
    const percentage = (mark / maxMark) * 100;

    if (percentage >= 90) return 'A';
    if (percentage >= 80) return 'B';
    if (percentage >= 70) return 'C';
    if (percentage >= 60) return 'D';
    if (percentage >= 35) return 'E';
    return 'F';
  };


  const getTotalMaxMarks = (subjects) => {
    return subjects.reduce((sum, data) => (
      sum + parseInt(data.total_theory_marks || 0) + parseInt(data.total_practical_marks || 0)
    ), 0);
  };

  const getTotalObtainedMarks = (subjects) => {
    return subjects.reduce((sum, data) => (
      sum + parseInt(data.student_theory_mark || 0) + parseInt(data.student_practical_mark || 0)
    ), 0);
  };

  const getSubjectMaxMark = (data) => {
    return parseInt(data.total_theory_marks || 0) + parseInt(data.total_practical_marks || 0);
  };

  const getSubjectObtainedMark = (data) => {
    return parseInt(data.student_theory_mark || 0) + parseInt(data.student_practical_mark || 0);
  };


  // --- PDF Download Logic ---
  const downloadReport = async () => {
    setIsDownloading(true);
    setProgress({ current: 0, total: rcard.length });

    // Initialize PDF with A4 dimensions
    const pdf = new jsPDF("p", "mm", "a4");
    const reportCards = document.querySelectorAll("#report-card");

    for (let i = 0; i < reportCards.length; i++) {
      const element = reportCards[i];

      // Small delay to ensure the chart is fully rendered before capture
      await new Promise((resolve) => setTimeout(resolve, 300));

      const canvas = await html2canvas(element, {
        scale: 3,
        useCORS: true,
        scrollY: -window.scrollY,
        backgroundColor: "#ffffff"
      });

      const imgData = canvas.toDataURL("image/jpeg", 0.9); // Use 0.9 quality
      const imgProps = pdf.getImageProperties(imgData);

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      if (i !== 0) {
        pdf.addPage();
      }

      pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight, undefined, "FAST");
      setProgress({ current: i + 1, total: reportCards.length });
    }

    pdf.save("Report_Cards.pdf");
    setIsDownloading(false);
  };


  // --- CHART DATA PREPARATION FUNCTION (Bar Chart) ---
  const prepareChartData = (subjects) => {
    const labels = subjects.map(s => s.subject_name);
    const maxScores = subjects.map(s => getSubjectMaxMark(s));
    const obtainedScores = subjects.map(s => getSubjectObtainedMark(s));

    // Find the highest score to set the y-axis max
    const maxMarkValue = Math.max(...maxScores) + 10; // Add buffer

    const chartData = {
      labels,
      datasets: [
        {
          label: 'Maximum Score',
          data: maxScores,
          backgroundColor: 'rgba(75, 192, 192, 0.8)',
          borderColor: 'rgb(75, 192, 192)',
          borderWidth: 1,
        },
        {
          label: 'Total Marks Obtained',
          data: obtainedScores,
          backgroundColor: 'rgba(255, 99, 132, 0.8)',
          borderColor: 'rgb(255, 99, 132)',
          borderWidth: 1,
        },
      ],
    };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'top',
        },
        title: {
          display: true,
          text: 'Performance Analysis Chart',
        },
      },
      scales: {
        y: {
          beginAtZero: true,
          max: maxMarkValue,
          title: {
            display: false,
            text: 'Marks'
          }
        },
        x: {
          title: {
            display: false,
            text: 'Subjects'
          }
        }
      }
    };

    return { chartData, options };
  };


  // --- Component JSX Rendering ---
  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">Report Card Detail</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Exam Module</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Report Card Detail
          </li>
        </ol>
      </div>

      <div className="card mb-3">
        <div className="card-body">
          <div className="row">
            {/* Academy Filter */}
            {localStorage.getItem("Role") === "1" && (
              <div className="col-xl-4 col-sm-6">
                <div className="mb-3">
                  <label className="form-label">
                    Select Academy <span className="text-danger"> *</span>
                  </label>
                  <Select
                    className="default-select"
                    placeholder="Select Academy"
                    value={acaid}
                    options={aclist}
                    onChange={handleAcademy}
                    isSearchable={true}
                    isClearable
                    hidden
                  />
                </div>
              </div>
            )}

            {/* Academic Year Filter */}
            <div className="col-xl-4 col-sm-6">
              <div className="mb-3">
                <label className="form-label">Academic Year</label>
                <select
                  className="default-select form-control wide"
                  onChange={(e) =>
                    filterstu(acaid, e.target.value, stucls, stusec)
                  }
                  value={ayear}
                >
                  <option value="" disabled>
                    Select Academic Year
                  </option>
                  {alist.map((item) => (
                    <option value={item.value} key={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Class Filter */}
            <div className="col-xl-4 col-sm-6">
              <div className="mb-3">
                <label className="form-label">Class</label>
                <select
                  className="default-select form-control wide"
                  onChange={(e) =>
                    filterstu(acaid, ayear, e.target.value, stusec)
                  }
                  value={stucls}
                >
                  <option value="" disabled>
                    Select Class
                  </option>
                  {clist.map((item) => (
                    <option value={item.value} key={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Section Filter */}
            <div className="col-xl-4 col-sm-6">
              <div className="mb-3">
                <label className="form-label">Section</label>
                <select
                  className="default-select form-control wide"
                  onChange={(e) =>
                    filterstu(acaid, ayear, stucls, e.target.value)
                  }
                  value={stusec}
                >
                  <option value="" disabled>
                    Select Section
                  </option>
                  {seclist.map((item) => (
                    <option value={item.value} key={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Exam Title Filter */}
            <div className="col-xl-4 col-sm-6">
              <div className="mb-6">
                <label className="form-label">Exam Title</label>
                <select
                  className="default-select form-control wide"
                  onChange={(e) => listcard(stuname, e.target.value, ayear, stucls, stusec)}
                  value={etitle}
                >
                  <option value="">Select Exam Title</option>
                  {tlist.map((item) => (
                    <option value={item.value} key={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Student Filter */}
            <div className="col-xl-4 col-sm-6">
              <div className="mb-3">
                <label className="form-label">Student</label>
                <Select
                  className="default-select"
                  placeholder="Select Student"
                  value={stuname}
                  options={stulist}
                  onChange={handleStu}
                  isSearchable={true}
                  isClearable
                  isMulti
                  hidden
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Download Button and Progress */}
      <div className="text-right mt-4 mb-4">
        <button
          className="btn btn-success"
          onClick={downloadReport}
          disabled={isDownloading || rcard.length === 0}
        >
          {isDownloading ? "Generating PDF..." : "Download Report Card"}
        </button>
        {isDownloading && (
          <div style={{ marginTop: 10 }}>
            <progress
              value={progress.current}
              max={progress.total}
              style={{ width: "100%", height: "20px" }}
            />
            <div style={{ textAlign: "center", marginTop: 5, fontWeight: "bold" }}>
              Generating PDF {progress.current} of {progress.total}
            </div>
          </div>
        )}
      </div>


      {/* Report Card Rendering Loop */}
      {rcard.map((item, i) => {
        const totalMaxMarks = getTotalMaxMarks(item.subjects);
        const totalObtainedMarks = getTotalObtainedMarks(item.subjects);
        const { chartData, options } = prepareChartData(item.subjects);

        return (
          // The main container for the single report card
          <div id="report-card" key={i} className="report-card-container" style={reportCardStyles.container}>

            {/* Header Section */}
            <div className="report-card-header" style={reportCardStyles.header}>
              <div style={reportCardStyles.logoContainer}>
                {item.logo !== "" && (
                  <img
                    src={item.path + item.logo}
                    alt="Academy Logo"
                    onError={errorhandle}
                    style={reportCardStyles.logo}
                  />
                )}
                {item.logo === "" && (
                  <img
                    src={require("../../../assets/images/logo/logo.png")}
                    alt="Academy Logo"
                    style={reportCardStyles.logo}
                  />
                )}
              </div>
              <div style={reportCardStyles.titleBlock}>
                <div style={reportCardStyles.schoolName}>{item.academy_name}</div>
                <div style={reportCardStyles.schoolAddress}>{item.address}</div>
                <div style={reportCardStyles.recordTitle}>
                  Record of Academic Performance - {item.exam_title.toUpperCase()}, {item.academic_year}
                </div>
              </div>
            </div>

            {/* Student Info Grid */}
            <div style={reportCardStyles.infoGridContainer}>
              <div style={reportCardStyles.infoRow}>
                <div style={reportCardStyles.infoLabel}>Name:</div>
                <div style={reportCardStyles.infoValue}><strong>{item.name}</strong></div>
                <div style={reportCardStyles.infoLabel}>Username:</div>
                <div style={reportCardStyles.infoValue}><strong>{item.username}</strong></div>
              </div>
              <div style={reportCardStyles.infoRow}>
                <div style={reportCardStyles.infoLabel}>Father's Name:</div>
                <div style={reportCardStyles.infoValue}><strong>{item.father_name}</strong></div>
                <div style={reportCardStyles.infoLabel}>Class / Div:</div>
                <div style={reportCardStyles.infoValue}><strong>{item.class_name} - {item.section_name}</strong></div>
              </div>
              <div style={reportCardStyles.infoRow}>
                <div style={reportCardStyles.infoLabel}>Mother's Name:</div>
                <div style={reportCardStyles.infoValue}><strong>{item.mother_name}</strong></div>
                <div style={reportCardStyles.infoLabel}></div>
                <div style={reportCardStyles.infoValue}></div>
              </div>
              <div style={reportCardStyles.infoRow}>
                <div style={reportCardStyles.infoLabel}>Adm No:</div>
                <div style={reportCardStyles.infoValue}><strong>{item.admission_number}</strong></div>
                <div style={reportCardStyles.infoLabel}>DOB:</div>
                <div style={reportCardStyles.infoValue}><strong>{moment(item.dob).format("DD/MM/YYYY")}</strong></div>
              </div>

            </div>


            {/* Subject Marks Table */}
            <table style={reportCardStyles.marksTable} cellSpacing="0" cellPadding="5">
              <thead>
                <tr>
                  <th style={{ ...reportCardStyles.tableCell, ...reportCardStyles.tableHeadCell, width: '10%' }}>Sl.No</th>
                  <th style={{ ...reportCardStyles.tableCell, ...reportCardStyles.tableHeadCell, width: '25%' }}>Subject</th>
                  <th style={{ ...reportCardStyles.tableCell, ...reportCardStyles.tableHeadCell, width: '20%' }}>Max Score</th>
                  <th style={{ ...reportCardStyles.tableCell, ...reportCardStyles.tableHeadCell, width: '20%' }}>Marks Obtained</th>
                  <th style={{ ...reportCardStyles.tableCell, ...reportCardStyles.tableHeadCell, width: '10%' }}>Total</th>
                  <th style={{ ...reportCardStyles.tableCell, ...reportCardStyles.tableHeadCell, width: '10%' }}>Grade</th>
                </tr>
              </thead>

              <tbody>
                {item.subjects.map((data, j) => {
                  const subjectMax = getSubjectMaxMark(data);
                  const subjectObtained = getSubjectObtainedMark(data);
                  const grade = getGrade(subjectObtained, subjectMax);

                  return (
                    <tr key={j}>
                      <td style={{ ...reportCardStyles.tableCell, textAlign: 'center' }}>{j + 1}</td>
                      <td style={reportCardStyles.tableCell}>{data.subject_name}</td>
                      <td style={{ ...reportCardStyles.tableCell, textAlign: 'center' }}>{subjectMax}</td>
                      <td style={{ ...reportCardStyles.tableCell, textAlign: 'center' }}>{subjectObtained}</td>
                      <td style={{ ...reportCardStyles.tableCell, textAlign: 'center', fontWeight: 'bold' }}>{subjectObtained}</td>
                      <td style={{ ...reportCardStyles.tableCell, textAlign: 'center', fontWeight: 'bold' }}>{grade}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

            {/* Grade Key / Remarks */}
            <div style={reportCardStyles.remarksContainer}>
              <div style={reportCardStyles.gradeKey}>
                <span>A = 90 - 100</span>
                <span>B = 80 - 89</span>
                <span>C = 70 - 79</span>
                <span>D = 60 - 69</span>
                <span>E = 35 - 59</span>
                <span>F = 1 - 34</span>
              </div>
              <div style={reportCardStyles.attendance}>
                <span style={{ fontWeight: 'bold' }}>Attendance </span>
                <span>No of working days: {item.working_days || 0}</span>
                <span>No of days present: {item.present_days || 0}</span>
              </div>
            </div>

            {/* BAR CHART Implementation */}
            <div style={reportCardStyles.chartContainer}>
              {item.subjects.length > 0 ? (
                <Bar data={chartData} options={options} />
              ) : (
                <div style={reportCardStyles.chartPlaceholderText}>No subject data available to generate chart.</div>
              )}
            </div>

            <div style={{ marginTop: '10px', fontSize: '12px', paddingLeft: '5px' }}>
              <span style={{ marginRight: '20px' }}><strong>Total Marks Obtained:</strong> {totalObtainedMarks}</span>
              <span><strong>Maximum Marks:</strong> {totalMaxMarks}</span>
            </div>

            <div style={{ marginTop: '15px', fontSize: '14px', paddingLeft: '5px' }}>
              <span style={{ marginRight: '20px' }}><strong>Remarks:</strong> </span>
            </div>

            <div style={{ fontSize: '12px', paddingLeft: '5px', paddingTop: '5px' }}>
              Issued On:
              {/* {moment().format("DD-MM-YYYY")}  borderTop: '1px solid #ccc', marginTop: '15px',  */}
            </div>

            {/* Signature Section */}
            <div style={reportCardStyles.signatureSection}>
              <div style={reportCardStyles.signatureBlock}>
                <div style={reportCardStyles.signatureLabel}>Principal Signature</div>
                <div style={reportCardStyles.signatureLine}></div>
              </div>
              <div style={reportCardStyles.signatureBlock}>
                <div style={reportCardStyles.signatureLabel}>Teacher Signature</div>
                <div style={reportCardStyles.signatureLine}></div>
              </div>
              <div style={{ flex: 1 }}></div> {/* Spacer */}
              <div style={reportCardStyles.signatureBlock}>
                <div style={reportCardStyles.signatureLabel}>Parent Signature</div>
                <div style={reportCardStyles.signatureLine}></div>
              </div>
            </div>


          </div>
        )
      })}


    </div>
  );
}

// Inline Styles to mimic the look of the report card
const reportCardStyles = {
  container: {
    width: '210mm',
    minHeight: '297mm',
    margin: '10px auto',
    padding: '20px',
    // border: '1px solid #000',
    fontFamily: 'Arial, sans-serif',
    fontSize: '12px',
    backgroundColor: '#fff',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    borderBottom: '2px solid #000',
    paddingBottom: '10px',
    marginBottom: '10px',
  },
  logoContainer: {
    width: '15%',
    textAlign: 'center',
  },
  logo: {
    width: '200px',
    height: 'auto',
  },
  titleBlock: {
    width: '85%',
    textAlign: 'center',
    lineHeight: '1.2',
  },
  schoolName: {
    fontSize: '18px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  schoolAddress: {
    fontSize: '14px',
  },
  recordTitle: {
    fontSize: '15px',
    fontWeight: 'bold',
    marginTop: '5px',
    backgroundColor: '#ccc',
    padding: '3px 0',
  },
  infoGridContainer: {
    border: '1px solid #000',
    padding: '5px',
    marginBottom: '10px',
    fontSize: '14px',
    backgroundColor: '#e9e9e9',
  },
  infoRow: {
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: '2px',
  },
  infoLabel: {
    width: '20%',
    paddingRight: '5px',
    fontWeight: 'normal',
  },
  infoValue: {
    width: '30%',
    fontWeight: 'bold',
  },
  marksTable: {
    width: '100%',
    border: '1px solid #000',
    borderCollapse: 'collapse',
    marginBottom: '10px',
  },
  tableHeadRow: {
    backgroundColor: '#002147',
    color: '#fff',
    fontWeight: 'bold',
  },
  tableCell: {
    border: '1px solid #000',
    padding: '5px',
    fontSize: '14px',
  },
  remarksContainer: {
    border: '1px solid #000',
    marginBottom: '10px',
    padding: '5px',
    backgroundColor: '#ccc',
  },
  gradeKey: {
    display: 'flex',
    justifyContent: 'space-around',
    fontSize: '12px',
    borderBottom: '1px solid #000',
    paddingBottom: '5px',
    marginBottom: '5px',
    flexWrap: 'wrap',
  },
  attendance: {
    display: 'flex',
    justifyContent: 'space-around',
    fontSize: '12px',
    backgroundColor: '#ccc',
  },
  chartContainer: {
    height: '220px', // Set a fixed height for the chart
    border: '1px solid #000',
    padding: '10px',
    backgroundColor: '#f9f9f9',
    position: 'relative', // Necessary for Chart.js to fill the container
  },
  chartPlaceholderText: {
    textAlign: 'center',
    paddingTop: '80px',
    fontSize: '14px',
    color: '#777',
  },
  tableHeadCell: {
    backgroundColor: '#777', // Dark blue
    color: '#ffffff',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  signatureSection: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '40px',
    padding: '0 10px',
    alignItems: 'flex-end',
  },
  signatureBlock: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '200px',
  },
  signatureLine: {
    width: '100%',
    // borderTop: '1px solid #000',
    marginTop: '5px',
  },
  signatureLabel: {
    fontSize: '12px',
    fontWeight: 'bold',
  },

};